module.exports = __webpack_public_path__ + "vue_assets/img/badge_deios_bronze.73ab7563.png";